import { Component, Input } from '@angular/core';
import { TaskStatus } from '@fairandsmart/types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'fs-task-status',
    templateUrl: './task-status.component.html',
    styleUrls: ['./task-status.component.scss'],
    imports: [TranslatePipe]
})
export class TaskStatusComponent {
  @Input()
    status: TaskStatus;
}
